import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { ProductVoucher } from '@/domainLogic/types/typesProduct.ts';
import { Currency, VOUCHER_TYPE } from '@/domainLogic/index.ts';

const getDiscountCurrency = (voucher: ProductVoucher, localization: Localization): string => {
  const hasDiscountCurrency = voucher && voucher.discountCurrency;
  const isValidCurrency = Object.values(Currency).includes(voucher.discountCurrency as Currency);
  const isDiscountCurrencyValid = hasDiscountCurrency && isValidCurrency;
  return isDiscountCurrencyValid ? voucher.discountCurrency : localization.currency;
};

const formatVoucherTextWithAmount = (voucherText: string, amount: string): string => {
  if (voucherText.includes('__amount__')) {
    return voucherText.replace('__amount__', amount);
  }

  return voucherText;
};

export const getVoucherText = (
  voucher: ProductVoucher,
  localization: Localization,
  t: TranslationFunction
): string | null => {
  const isPercentage = voucher.discountType === VOUCHER_TYPE.PERCENTAGE;
  const isFixed = voucher.discountType === VOUCHER_TYPE.FIXED;
  const voucherText = t('vacation.oss.usp.voucher.amount');

  if (isFixed) {
    const discountCurrency = getDiscountCurrency(voucher, localization);
    const formattedPriceStr = formatPrice({
      price: voucher.discountValue,
      localization,
      currency: discountCurrency,
    });
    return formatVoucherTextWithAmount(voucherText, formattedPriceStr);
  }

  if (isPercentage) {
    return formatVoucherTextWithAmount(voucherText, `${voucher.discountValue}%`);
  }

  return null;
};
